module.exports = __webpack_public_path__ + "fonts/SegoeUI-SemiBold.a761b472.ttf";